module.exports = __webpack_public_path__ + "static/media/share_24px.9478e9a5.svg";